import { render, staticRenderFns } from "./TwPreviewJson.vue?vue&type=template&id=52976f56&"
import script from "./TwPreviewJson.vue?vue&type=script&lang=js&"
export * from "./TwPreviewJson.vue?vue&type=script&lang=js&"
import style0 from "./TwPreviewJson.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports